/* eslint-disable camelcase */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from "prop-types";
import { connect } from 'react-redux';
import { Layout } from '../EditWellnessJourney/styles';
import { muscleGroup, fitnessLevel } from "../../../mockData";
import { addFitnessVideo, getVideosCategory } from '../../redux/actions';
import { withTranslation } from 'react-i18next';
import FormAddVideo from '../FormAddVideo/index';
import Waiting from '../Waiting';

const stateForAdd = {
  title: "",
  video_category_ids: [], 
  video_url: "",
  fitness_level: "",
  muscle_group: "",
  wellness_goal: null,
  question: null,
  level: null,
  themeName: "",
  theme_id: null,
  thumbnail_image: "",
  description: "",
  selectedOption: 0,
};

class AddFitnessVideo extends Component {
  constructor() {
    super();
    this.state = {
      showLoader: false,
    };
  }

  componentDidMount() {
    this.props.getVideosCategory();
  }

  onSubmit = (e, data) => {
    e.preventDefault();

    if(this.state.showLoader) return;

    const { addFitnessVideo, history, isAdminRoute } = this.props;

    let updateData = { ...data };

    if (updateData.fitness_level === 1) updateData.fitness_level = "Beginner";
    else if (updateData.fitness_level === 2) updateData.fitness_level = "Intermediate";
    else if (updateData.fitness_level === 3) updateData.fitness_level = "Advanced";
    else updateData.fitness_level = "None";

    const muscleMap = {
      1: "Back", 2: "Core", 3: "Hips", 4: "Legs", 5: "Shoulder",
      6: "Chest", 7: "Arms", 8: "Upper Body", 9: "Lower Body",
      10: "Total Body", 11: "Mindfulness", 12: "Mental Health"
    };
    updateData.muscle_group = muscleMap[updateData.muscle_group] || "None";
    updateData.levels = updateData.level?.level || null;
    updateData.question_id = updateData.question?.id || null;
    updateData.wellness_goal_id = updateData.wellness_goal?.id || null;
    
    updateData.thumbnail_image = updateData.thumbnail_image || updateData.imgSrc || null;

    updateData.video_categories = updateData.video_category_ids || [];

    updateData.description = updateData.description || "";

    const fieldsToRemove = [
      'wbaQuestions', 'wellnessGoals', 'showWbaQue', 'isDisabled', 
      'step', 'imageUpdated', 'charCount', 'themeOpen', 'levelOpen', 
      'goalOpen', 'questionOpen', 'muscleGroupOpen', 'fitnessLevelOpen',
      'isLoadingQuestions', 'video_category_ids', 'urlValid', 'selectedOption',
      'level', 'question', 'wellness_goal'
    ];
    
    fieldsToRemove.forEach((field) => delete updateData[field]);


    this.setState({
      showLoader: true
    }, () => {
      // Dispatch Action after state update
      addFitnessVideo(updateData, history, isAdminRoute);
    });
  };

  render() {
    const { videoLibraries, themes, t, themesHeaderAll, isAdminRoute, history } = this.props;

    if (this.state.showLoader && isAdminRoute) {
      return <Waiting />;
    }

    return (
      <Layout>
        <FormAddVideo
          t={t}
          history={history}
          state={stateForAdd}
          onSubmit={this.onSubmit}
          video_category_id={videoLibraries}
          muscle_group={muscleGroup}
          fitness_level={fitnessLevel}
          themes={themes}
          themesHeaderAll={themesHeaderAll}
          buttonText={t("Create")}
          isSubmitting={this.state.showLoader} // Pass the loading state
          isAdminRoute={isAdminRoute}
        />
      </Layout>
    );
  }
}

AddFitnessVideo.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  videoLibraries: PropTypes.array,
  addFitnessVideo: PropTypes.func.isRequired,
  themes: PropTypes.array.isRequired,
  themesHeaderAll: PropTypes.array,
  t: PropTypes.func,
  isAdminRoute: PropTypes.bool,
  getVideosCategory: PropTypes.func
};

const mapStateToProps = (state) => ({
  isLoading: state.education.isLoading,
  videoLibraries: state.education.videoLibraries
});

const mapDispatchToProps = (dispatch) => ({
  addFitnessVideo: (data, history, isAdminRoute) => dispatch(addFitnessVideo(data, history, isAdminRoute)),
  getVideosCategory: () => dispatch(getVideosCategory())
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AddFitnessVideo)));